import React, { useEffect, useState, useRef } from "react";

function GithubContributions() {
  const [weeks, setWeeks] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => {
    const fetchContributions = async () => {
      const cacheKey = "github-contributions-12";
      const cached = localStorage.getItem(cacheKey);

      if (cached) {
        try {
          const parsed = JSON.parse(cached);
          if (parsed.weeks && parsed.weeks.length > 0) {
            setWeeks(parsed.weeks || []);
            setTotal(parsed.totalContributions || 0);
          } else {
            setLoading(true);
          }
        } catch (e) {
          setLoading(true);
        }
      } else {
        setLoading(true);
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE}/api/github/contributions?months=12`
        );

        const calendar = await response.json();

        setWeeks(calendar.weeks || []);
        setTotal(calendar.totalContributions || 0);
        localStorage.setItem(cacheKey, JSON.stringify(calendar));
      } catch (error) {
        console.error("❌ Error fetching GitHub data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContributions();
  }, []);

  // 当数据加载或渲染后，默认滚动到最右侧（显示最新的贡献记录）
  useEffect(() => {
    if (scrollRef.current && weeks.length > 0) {
      scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
    }
  }, [weeks]);

  const activeDays = weeks.reduce((sum, week) => {
    return sum + (week.contributionDays?.filter((day) => day.contributionCount > 0).length || 0);
  }, 0);

  return (
    <div className="dashboard-github-card rounded w-full h-[170px] md:h-[190px] mb-4 mt-2 flex flex-col">
      <h3 className="text-[11px] md:text-sm font-semibold text-center mb-1" style={{ paddingTop: "8px" }}>
        Contributions
      </h3>

      {loading && weeks.length === 0 ? (
        <p className="text-xs md:text-sm text-center text-gray-500 my-auto">
          Loading data...
        </p>
      ) : (
        <>
          <p className="text-[9px] md:text-xs text-gray-500 text-center mb-2 flex-shrink-0">
            Total:{" "}
            <span className="font-bold text-black dark:text-white">
              {total}
            </span>
            <span className="mx-1">|</span>
            Active days:{" "}
            <span className="font-bold text-black dark:text-white">
              {activeDays}
            </span>
          </p>

          {/* ✅ 热力图：宽度内显示尽可能多，超出宽度支持左右滑动 */}
          <div
            ref={scrollRef}
            className="overflow-x-auto overflow-y-hidden px-2 flex-1 flex items-center"
            style={{
              scrollbarWidth: "thin",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <div className="flex mx-auto min-w-max py-1">
              {weeks.map((week, wIndex) => (
                <div
                  key={wIndex}
                  className="flex flex-col mr-[2px] md:mr-[3px]"
                >
                  {week.contributionDays.map((day) => (
                    <div
                      key={day.date}
                      title={`${day.date}: ${day.contributionCount} contributions`}
                      className="w-[9px] h-[9px] sm:w-[10px] sm:h-[10px] rounded-sm mb-[2px] md:mb-[3px] flex-shrink-0"
                      style={{ backgroundColor: day.color }}
                    ></div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* 图例 */}
          <div className="flex items-center justify-center gap-[2px] sm:gap-1 mt-1 text-[8px] sm:text-xs text-gray-500 flex-shrink-0">
            <span>Less</span>
            <div className="w-[4px] h-[4px] sm:w-3 sm:h-3 bg-gray-200 rounded-sm"></div>
            <div className="w-[4px] h-[4px] sm:w-3 sm:h-3 bg-[#9be9a8] rounded-sm"></div>
            <div className="w-[4px] h-[4px] sm:w-3 sm:h-3 bg-[#40c463] rounded-sm"></div>
            <div className="w-[4px] h-[4px] sm:w-3 sm:h-3 bg-[#30a14e] rounded-sm"></div>
            <div className="w-[4px] h-[4px] sm:w-3 sm:h-3 bg-[#216e39] rounded-sm"></div>
            <span>More</span>
          </div>
        </>
      )}
    </div>
  );
}

export default GithubContributions;
